export default {
  "name": "NCDragWidthCom",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCDragWidthCom",
  "label": "左右分栏",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "defLeftWid": {
        "title": "defLeftWid",
        "description": "左侧宽度",
        "type": "string",
        "default": "150px"
      },
      "leftMinWid": {
        "title": "leftMinWid",
        "description": "左侧最小宽度",
        "type": "string",
        "default": "50px"
      },
      "leftDom": {
        "title": "leftDom",
        "description": "左侧栏目",
        "type": "node"
      },
      "rightDom": {
        "title": "rightDom",
        "description": "右侧栏目",
        "type": "node"
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": [
    "leftDom",
    "rightDom"
  ]
}